import React from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './ReportWizardPage.css';

export function ReportWizardPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  
  return (
    <div className="report-wizard-page">
      <div className="report-wizard-page__container">
        <h1>{t('reports.wizard.title')}</h1>
        <p>{t('reports.wizard.reportId', { id: id || t('reports.wizard.new') })}</p>
        <p>{t('reports.wizard.comingSoon')}</p>
      </div>
    </div>
  );
}

export default ReportWizardPage;
